module.exports = __webpack_public_path__ + "img/reference-sporthotspot.c78d2265.webp";